import numbro from 'numbro';

// display amounts in the following format : 1.3Me
export const keyIndicatorsCurrencyFormatter = (value: number) =>
    numbro(value).formatCurrency({ average: true, mantissa: 2 });
